export default {"src":"/_next/static/media/EEM.42c71440.svg","height":18,"width":18};